export const EvaluationPerformanceFileModel = {
    path: '/evaluation_performance_file_models',
    name: 'evaluation_performance_file_models',
    component: () => import('@/views/Evaluation/FileModel/EvaluationPerformanceFileModelPage.vue'),
    props: {type: 'EVALUATION_PERFORMANCE'},
    children: [
        {
            path: '/evaluation_performance_file_models/add',
            name: 'evaluation_performance_file_models.add',
            component: () => import('@/views/Evaluation/FileModel/Form/EvaluationFileModelForm.vue'),
            props: {addAction: true, type: 'EVALUATION_PERFORMANCE'}
        },
        {
            path: '/evaluation_performance_file_models/edit/:id',
            name: 'evaluation_performance_file_models.edit',
            component: () => import('@/views/Evaluation/FileModel/Form/EvaluationFileModelForm.vue'),
            props: {updateAction: true, type: 'EVALUATION_PERFORMANCE'}
        },
        {
            path: '/evaluation_performance_phase/delete/:id',
            name: 'evaluation_performance_file_models.delete',
            component: () => import('@/views/Evaluation/FileModel/Form/EvaluationFileModelForm.vue'),
            props: {deleteAction: true, type: 'EVALUATION_PERFORMANCE'}
        },
        {
            path: '/evaluation_performance_file_models/view/:id',
            name: 'evaluation_performance_file_models.view',
            component: () => import('@/views/Evaluation/FileModel/Form/EvaluationFileModelForm.vue'),
            props: {viewAction: true, type: 'EVALUATION_PERFORMANCE'}
        },
    ]
}